import {
  CarModelRef,
  LeasingCarDto,
  postCarsSearchSearchLeasing,
  postCarsSearchSearchSale,
  SaleCarDto,
  SearchCarsRequest,
} from "api"
import { fetchTermModelRefs, TermSearchItem } from "@eurodrive/utils"

export interface CarSearchResult {
  searchItems: TermSearchItem[]
  leasingCars: LeasingCarDto[]
  saleCars: SaleCarDto[]
  totalCount: number
}

const HEADER_RESULTS_PAGE_SIZE = 10

// Only `rawModels` is sent: raw `manufacturers` would cut the cars of a matched
// group that are filed under another manufacturer code of the same brand.
const termSearchRequest = (rawModels: CarModelRef[]) =>
  ({
    rawModels,
    pageSize: HEADER_RESULTS_PAGE_SIZE,
    requestPage: 0,
  }) as SearchCarsRequest

export const fetchSearchResults = async (
  text: string,
): Promise<CarSearchResult | null> => {
  const { items, leasing, sale } = await fetchTermModelRefs(text)

  if (items.length === 0) {
    return null
  }

  const [leasingResult, saleResult] = await Promise.allSettled([
    leasing.length > 0
      ? postCarsSearchSearchLeasing(termSearchRequest(leasing))
      : null,
    sale.length > 0 ? postCarsSearchSearchSale(termSearchRequest(sale)) : null,
  ])

  const leasingCars =
    (leasingResult.status === "fulfilled" &&
      leasingResult.value?.data.body?.items) ||
    []
  const saleCars =
    (saleResult.status === "fulfilled" && saleResult.value?.data.body?.items) ||
    []

  return {
    searchItems: items,
    leasingCars,
    saleCars,
    totalCount: leasingCars.length + saleCars.length,
  }
}
